import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { RegexUtil } from '../../../../../common/utils/regexUtil';

const MypagePaymentList = observer(({ items = [] }) => {
    const [expandedIndex, setExpandedIndex] = useState(null);

    return (
        <div className="list">
            {!!items &&
                items.length > 0 &&
                items.map((item, i) => {
                    let msg = '';
                    if (item.component === '@gift') {
                        msg = item.content.replace(/\(.*?\)/g, '');
                    } else {
                        msg = item.content;
                    }

                    // ✅ amount * times
                    const totalAmount =
                        Number(item.amount) * Number(item.times || 1);

                    const expanded = expandedIndex === i;

                    return (
                        <div key={i}>
                            {/* MAIN ROW */}
                            <div
                                className="item"
                                onClick={() =>
                                    item.items?.length > 0 &&
                                    setExpandedIndex(expanded ? null : i)
                                }
                            >
                <span className="info">
                  <em className="tx">{msg}</em>
                  <em className="date">{item.create_datetime}</em>
                </span>

                                <div className="right">
                  <span className="num">
                    {totalAmount > 0
                        ? `+${RegexUtil.makeComma(totalAmount)}`
                        : RegexUtil.makeComma(totalAmount)}
                  </span>

                                    {item.items?.length > 0 && (
                                        <img
                                            src="/images/chevron_right.svg"
                                            alt="expand"
                                            className={expanded ? 'rotated' : ''}
                                        />
                                    )}
                                </div>
                            </div>

                            {/* SUB ITEMS */}
                            {expanded &&
                                item.items?.map((sub, idx) => (
                                    <div className="item sub" key={idx}>
                    <span className="info">
                      <em className="tx">{sub.content}</em>
                      <em className="date">
                        {sub.create_datetime}
                      </em>
                    </span>
                                        <span className="num">
                      {Number(sub.amount) > 0
                          ? `+${RegexUtil.makeComma(sub.amount)}`
                          : RegexUtil.makeComma(sub.amount)}
                    </span>
                                    </div>
                                ))}
                        </div>
                    );
                })}
        </div>
    );
});

export { MypagePaymentList };
